import React from 'react';

import RequestField from '../request-field';

const RequestViewValue = (props) => {
  const { tLabel, value, children } = props;

  return (
    <RequestField tLabel={tLabel}>
      {children || (
        <div className="request-view-value">{value || '—'}</div>
      )}
    </RequestField>
  );
};

export default RequestViewValue;
